import { createContext, useContext } from 'react';

export interface PopupMessage {
  conversationId: string;
  expediteur: { id: string; nom: string; prenom: string; initiales: string };
  texte: string;
  envoyeLe: string;
  aPieceJointe: boolean;
}

interface ValeurReponseRapide {
  popups: PopupMessage[];
  fermer: (conversationId: string) => void;
}

export const ContexteReponseRapide = createContext<ValeurReponseRapide | null>(null);

/** Pop-ups façon Discord affichées à réception d'un message, quel que soit l'écran ouvert. */
export function useReponseRapide(): ValeurReponseRapide {
  const contexte = useContext(ContexteReponseRapide);
  if (!contexte) throw new Error('useReponseRapide doit être utilisé sous FournisseurAppel');
  return contexte;
}
